import { render, staticRenderFns } from "./ChengShu_survey.vue?vue&type=template&id=338c6c7c&scoped=true"
import script from "./ChengShu_survey.vue?vue&type=script&lang=js"
export * from "./ChengShu_survey.vue?vue&type=script&lang=js"
import style0 from "./ChengShu_survey.vue?vue&type=style&index=0&id=338c6c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c6c7c",
  null
  
)

export default component.exports